import React from 'react';
import './spinner.css';
import ComponentHelper from '../../supers/ComponentHelper';

export default class Spinner extends ComponentHelper {
	render() {
		let { height = '200px', text = '' } = this.props;
		return (
			<div className="vbox vhcenter spinner" style={{ height }}>
				<div className="ball" />
				{text && <span className="text">{text}</span>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.js